@mixin link {
  @apply text-gray-400 font-text no-underline cursor-pointer;
}

.footer {
  @apply flex w-full bg-black;

  .footer-container {
    @apply w-full font-text pt-[60px] pb-[20px] px-[120px];

    .footer-wrapper {
      @apply flex flex-wrap justify-between;

      .footer-section {
        @apply mt-[10px] mr-[10px] mb-[60px] ml-[10px] w-[240px];

        .footer-section-title {
          @apply font-text-bold text-copy leading-[40px] text-white pb-[20px];
        }

        .footer-section-item {
          @apply leading-[40px];

          a {
            @include link;
            @apply text-white text-copy-smaller font-medium;
          }
        }
      }
    }
  }

  .footer-bottom {
    @apply flex relative justify-between items-center w-full font-text text-copy-smaller font-medium text-gray-400;

    .footer-liebherr-icon {
      @apply cursor-pointer;
      padding: 0 0.8vw 0 10px;
    }

    .footer-additional-link {
      @apply flex leading-[30px];

      .footer-section-item {
        padding: 0 1.5vw 0 0;
        a {
          @include link;
        }
      }
    }

    .footer-arrow-icon {
      @apply absolute z-10 right-[-76px] bottom-[4px] cursor-pointer;
    }
  }

  .footer-portal {
    @apply w-full h-[96px] items-center justify-between flex-nowrap;

    & .footer-liebherr-icon {
      @apply pl-[120px] cursor-pointer;
    }

    .footer-portal-text {
      div {
        @apply px-[20px];
      }

      @apply text-white leading-4 font-text text-copy-extra-small;

      a {
        @include link;
      }
    }
  }
}

@media (max-width: theme('screens.md')) {
  .footer {
    .area-two {
      grid-area: 2 / 1 / auto / auto;
    }

    .area-three {
      grid-area: 2 / 2 / auto / auto;
      @apply pr-[20px] pb-[48px];
    }
  }
}

@media (max-width: theme('screens.xl')) {
  .footer {
    .footer-container {
      @apply pb-[40px];
      .footer-wrapper {
        padding: 60px 0 0 0;
        .footer-section {
          .footer-section-title {
            @apply pb-[0];
          }
        }
      }

      .footer-additional-link {
        .footer-section-item:last-child {
          @apply pb-[74px];
        }

        @apply block px-[10px] py-0;

        .footer-section-item {
          @apply leading-[40px] text-copy-smaller;
          a {
            @include link;
          }
        }
      }
    }

    .footer-bottom {
      @apply flex justify-between;

      .footer-arrow-icon {
        @apply relative right-0 bottom-0;
      }

      .footer-additional-link {
        @apply hidden;
      }
    }

    .footer-portal {
      & .footer-liebherr-icon {
        @apply pl-[20px];
      }
    }
  }
}

@media (max-width: theme('screens.lg')) {
  .footer {
    .footer-container {
      .footer-additional-link {
        .footer-section-item:last-child {
          @apply pb-[74px];
        }
      }
    }
  }
}

@media (max-width: theme('screens.md')) {
  .footer {
    .footer-container {
      padding: 40px 40px 40px 60px;

      .footer-wrapper {
        @apply p-0;
      }
    }
  }
}

@media (max-width: theme('screens.md')) {
  .footer {
    .footer-portal {
      @apply h-auto;

      & .footer-liebherr-icon {
        @apply pb-[48px];
      }

      .footer-portal-text {
        @apply pb-[48px];
        div {
          @apply pb-[24px];
        }
      }
    }
  }
}
